import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {GameInfo} from "../../../../services/games/game-info";
import React from 'react';
import {LiveCasinoGridItemThumbnailImageBox} from "../../../arena-host/new-live-casino-arena/live-casino-arena-grid/boxes/thumbnail/live-casino-grid-item-thumbnail-image.box";
import {Check} from "@sparkware/app-utils";
import {addQueryParam} from "../../../../../utils/url-utils";

export interface VideoThumbnailImageComponentProps {
    onLoad: () => void;
    onSettled: () => void;
    gameInfo: GameInfo;
    filterBlur: boolean;
}

export default class VideoThumbnailImageComponent extends OrbitComponent<VideoThumbnailImageComponentProps> {

    //Priority for game video thumbnail image(takes the 1st that exists):
    // gameinfo.videoThumbnailUrl
    // tableinfo.TableImage
    // gameinfo.gameArenaIcon

    private _getImageSource = (): string => {
        const gameInfo: GameInfo = this.props.gameInfo;

        if (gameInfo?.videoThumbnailUrl) {
            return gameInfo?.videoThumbnailUrl;
        }

        const tableInfo = this.services.liveTableFeeds.getTableInfo(gameInfo.gameType);

        if (Check.isEmpty(tableInfo) || !tableInfo.TableImage) {
            return gameInfo?.gameArenaIcon;
        } else {
            // We need this random because we want to force react to reload the image because the url of the image is identical but the image changed.
            let imageRandom = Math.random();

            return addQueryParam(tableInfo.TableImage, imageRandom.toString());
        }
    };

    render(): React.ReactNode {
        return (<LiveCasinoGridItemThumbnailImageBox
            width={432} height={243}
            lazy src={this._getImageSource()}
            alt={this.props.gameInfo?.title}
            className={'cy-live-casino-grid-item-thumbnail-image'}
            onLoad={this.props.onLoad}
            onSettled={this.props.onSettled}
            filterBlur={this.props.filterBlur}
        />);
    }
}
